import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GraphService } from 'src/app/shared/lib/api/graph.service';
import { GraphQLHelper } from 'src/app/shared/lib/helpers/graphql.helper';
import {
  buildGetAllAdminProviderQuery,
  DEFAULT_ADMIN_PROVIDER_FIELDS,
  queryGetAllProviderAdmin,
  queryGetProviderAdminById,
} from '../graphql/proveedores.queries';
import { createProviderAdmin, deleteProviderAdmin, updateProviderAdmin } from '../graphql/proveedores.mutations';

@Injectable({ providedIn: 'root' })
export class ProveedoresAdminService {
  constructor(
    private graphService: GraphService,
    private graphQLHelper: GraphQLHelper,
  ) {}

  private buildFields(projectionExpression: string | undefined): string {
    const selectedFields = projectionExpression
      ? projectionExpression
        .split(',')
        .map((f) => f.trim())
        .filter(Boolean)
      : DEFAULT_ADMIN_PROVIDER_FIELDS;

    return this.graphQLHelper.buildGraphQLFields(selectedFields);
  }

  getAllWithProjection(projectionExpression?: string): Observable<any[]> {
    const fields = this.buildFields(projectionExpression);
    const query = buildGetAllAdminProviderQuery(fields);

    return this.graphService
      .queryGraphQL<{ getAllProvider: any[] }>({
        query,
        variables: {},
      })
      .pipe(
        map((response) => response.getAllProvider || []),
        catchError((error) => {
          console.error('Error fetching proveedores admin:', error);
          return throwError(() => new Error('Error al obtener proveedores'));
        }),
      );
  }

  getAll(): Observable<any[]> {
    //TODO: Hay que utilizar interfaces para los metodos en general, para evitar el uso de 'any' y mejorar la tipificación.
    return this.graphService
      .queryGraphQL<{ getAllProvider: any[] }>({
        query: queryGetAllProviderAdmin,
        variables: {},
      })
      .pipe(
        map((response) => response.getAllProvider || []),
        catchError((error) => {
          console.error('Error fetching proveedores admin:', error);
          return throwError(() => new Error('Error al obtener proveedores'));
        }),
      );
  }

  getById(id: String): Observable<any> {
    return this.graphService
      .queryGraphQL<any>({
        query: queryGetProviderAdminById,
        variables: { id },
      })
      .pipe(
        map((response) => response.getProvider || null),
        catchError((error) => {
          console.error('Error fetching proveedor admin by ID:', error);
          return throwError(() => new Error('Error al obtener proveedor por ID'));
        })
      );
  }

  create(provider: any): Observable<any> {
    return this.graphService
      .mutateGraphQL<any>({
        mutation: createProviderAdmin,
        variables: { provider },
      })
      .pipe(
        map((response) => response.createProvider),
        catchError((error) => {
          console.error('Error creating proveedor admin:', error);
          return throwError(() => new Error('Error al crear proveedor'));
        })
      );
  }

  update(id: any, provider: any): Observable<any> {
    return this.graphService
      .mutateGraphQL<any>({
        mutation: updateProviderAdmin,
        variables: { id, provider },
      })
      .pipe(
        map((response) => response.updateProvider),
        catchError((error) => {
          console.error('Error updating proveedor admin:', error);
          return throwError(() => new Error('Error al actualizar proveedor'));
        })
      );
  }

  delete(id: any): Observable<any> {
    return this.graphService
      .mutateGraphQL<any>({
        mutation: deleteProviderAdmin,
        variables: { id },
      })
      .pipe(
        map((response) => response.deleteProvider),
        catchError((error) => {
          console.error('Error deleting proveedor admin:', error);
          return throwError(() => new Error('Error al eliminar proveedor'));
        })
      );
  }
}
